const supportedTypes = new Set(['text', 'textarea', 'date']);
const stableId = /^[A-Za-z0-9_][A-Za-z0-9_.:-]{0,127}$/;
export const DEFAULT_INTERNAL_REPORT_PRESENTATION = Object.freeze({
  headingText:'internal report',
  footerText:'Internal Reports · separate need-to-know register',
});
let fallbackSequence = 0;

export function newInternalReportId(prefix) {
  const suffix = globalThis.crypto?.randomUUID?.().replace(/-/g, '_')
    || `${Date.now().toString(36)}_${(++fallbackSequence).toString(36)}`;
  return `${prefix}_${suffix}`;
}

export function moveInternalReportItem(items, index, direction) {
  const target = index + direction;
  if (index < 0 || index >= items.length || target < 0 || target >= items.length) return items;
  const next = [...items];
  [next[index], next[target]] = [next[target], next[index]];
  return next;
}

export function validateInternalReportSettings(settings = {}) {
  const issues = [];
  if (!Number.isInteger(Number(settings.deadlineDays)) || Number(settings.deadlineDays) < 1) issues.push('Enter a positive whole number of deadline days.');
  const presentation = settings.documentPresentation || DEFAULT_INTERNAL_REPORT_PRESENTATION;
  if (typeof presentation.headingText !== 'string' || !presentation.headingText.trim() || presentation.headingText.length > 120)
    issues.push('Enter a document heading of 1–120 characters after the report type.');
  if (typeof presentation.footerText !== 'string' || presentation.footerText.length > 300)
    issues.push('Keep document footer text within 300 characters.');
  const sections = settings.formDefinition?.sections;
  if (!Array.isArray(sections) || !sections.length) return [...issues, 'Add at least one form section.'];
  const sectionIds = new Set(), questionIds = new Set();
  sections.forEach((section, sectionIndex) => {
    const name = `Section ${sectionIndex + 1}`;
    const id = String(section?.id || '');
    if (!stableId.test(id) || sectionIds.has(id.toLowerCase())) issues.push(`${name} needs a valid, unique identifier.`);
    sectionIds.add(id.toLowerCase());
    if (!String(section?.label || '').trim()) issues.push(`${name} needs a title.`);
    if (!Array.isArray(section?.questions) || !section.questions.length) {
      issues.push(`${String(section?.label || name)} needs at least one question.`);
      return;
    }
    section.questions.forEach((question, questionIndex) => {
      const label = `${section.label || name}, question ${questionIndex + 1}`;
      const questionId = String(question?.id || '');
      if (!stableId.test(questionId) || questionIds.has(questionId.toLowerCase())) issues.push(`${label} needs a valid identifier that is unique across the form.`);
      questionIds.add(questionId.toLowerCase());
      if (!String(question?.label || '').trim()) issues.push(`${label} needs a label.`);
      if (!supportedTypes.has(question?.type)) issues.push(`${label} needs a supported answer type.`);
      if (question?.required !== undefined && typeof question.required !== 'boolean') issues.push(`${label} has an invalid required setting.`);
    });
  });
  return issues;
}
